import React from "react";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Col, Row } from "styles";
import { Table } from "../../style";

export function Others(props) {
  return (
    <>
      <Row>
        <Col>
          <Input
            type="checkbox"
            params="additions.others.emulsifiers"
            item={props.meggProduction}
            setItem={props.setMeggProduction}
            label="Utiliza Emulsificantes"
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Input
            type="checkbox"
            params="additions.others.pigmentation"
            item={props.meggProduction}
            setItem={props.setMeggProduction}
            label={` Utiliza Pigmentante
            ${
              props.meggProduction.additions.others.pigmentation ? ", Qual" : ""
            }?`}
            className="kt-checkbox pr-15"
          />
          {props.meggProduction.additions.others.pigmentation && (
            <Input
              type="input"
              label=" "
              params="additions.others.pigmentationType"
              item={props.meggProduction}
              setItem={props.setMeggProduction}
              placeholder={
                props.meggProduction.additions.others.pigmentation
                  ? "Digite o pigmentante"
                  : ""
              }
              disabled={!props.meggProduction.additions.others.pigmentation}
            />
          )}
        </Col>
      </Row>
      {props.meggProduction.additions.others.pigmentation && (
        <Row>
          <Col>
            <Table>
              <Header>
                <tr>
                  <th style={{ width: "185px" }}>
                    <span></span>
                  </th>
                  <th>
                    <span>Qual PPM Amarelo?</span>
                  </th>
                  <th>
                    <span>Qual PPM Vermelho?</span>
                  </th>
                </tr>
              </Header>
              <Body>
                <tr>
                  <td>
                    <span>Pré Postura</span>
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.preLay.yellowppm"
                      item={props.meggProduction}
                      setItem={props.setMeggProduction}
                    />
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.preLay.redppm"
                      item={props.meggProduction}
                      setItem={props.setMeggProduction}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Pré Pico</span>
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.prePeak.yellowppm"
                      item={props.meggProduction}
                      setItem={props.setMeggProduction}
                    />
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.prePeak.redppm"
                      item={props.meggProduction}
                      setItem={props.setMeggProduction}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Pico de Postura</span>
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.layPeak.yellowppm"
                      item={props.meggProduction}
                      setItem={props.setMeggProduction}
                    />
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.layPeak.redppm"
                      item={props.meggProduction}
                      setItem={props.setMeggProduction}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Postura 01</span>
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.layFinal01.yellowppm"
                      item={props.meggProduction}
                      setItem={props.setMeggProduction}
                    />
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.layFinal01.redppm"
                      item={props.meggProduction}
                      setItem={props.setMeggProduction}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Postura 02</span>
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.layFinal02.yellowppm"
                      item={props.meggProduction}
                      setItem={props.setMeggProduction}
                    />
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.layFinal02.redppm"
                      item={props.meggProduction}
                      setItem={props.setMeggProduction}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Postura 03</span>
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.layFinal03.yellowppm"
                      item={props.meggProduction}
                      setItem={props.setMeggProduction}
                    />
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.layFinal03.redppm"
                      item={props.meggProduction}
                      setItem={props.setMeggProduction}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Postura 04</span>
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.layFinal04.yellowppm"
                      item={props.meggProduction}
                      setItem={props.setMeggProduction}
                    />
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.layFinal04.redppm"
                      item={props.meggProduction}
                      setItem={props.setMeggProduction}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Postura 05</span>
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.layFinal05.yellowppm"
                      item={props.meggProduction}
                      setItem={props.setMeggProduction}
                    />
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.layFinal05.redppm"
                      item={props.meggProduction}
                      setItem={props.setMeggProduction}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>Postura 06</span>
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.layFinal06.yellowppm"
                      item={props.meggProduction}
                      setItem={props.setMeggProduction}
                    />
                  </td>
                  <td>
                    <Input
                      type="inputOnly"
                      params="additions.others.layFinal06.redppm"
                      item={props.meggProduction}
                      setItem={props.setMeggProduction}
                    />
                  </td>
                </tr>
              </Body>
            </Table>
          </Col>
        </Row>
      )}
    </>
  );
}
